var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"fullscreen":"","value":1}},[_c('div',{staticClass:"popup red lighten-2 white--text"},[_c('div',{staticClass:"d-flex flex-column text-center"},[_c('h2',{staticClass:"text-h3"},[_vm._v(_vm._s(_vm.$t('general.landscape')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }